e4.redirect = {
    localStorageKey: 'e4.redirect.consent',
    init: function () {
        var jRedirectModal = jQuery( '#js-e-redirect-msg' );
        if ( jRedirectModal.length === 1 && e4.redirect.getUserConsent() !== false ) {
            e4.redirect.bindEvents();
            jRedirectModal.modal( 'show' );
        }
    },
    bindEvents: function () {
        jQuery( '#js-e-redirect-msg' ).on( 'hide.bs.modal', function ( event ) {
            e4.redirect.setUserConsent( jQuery( event.target ).data( 'redirectConsentExpiration' ) );
        } );
    },
    setUserConsent: function ( intExpiresInDays ) {
        var intExpiresInMilliSeconds = Math.round( ( jQuery.isNumeric( intExpiresInDays ) === true ? intExpiresInDays : 1 ) * 24 * 60 * 60 * 1000 ),
            jsonStorage = {
                value: JSON.stringify( false ),
                timestamp: new Date().getTime() + intExpiresInMilliSeconds
            };
        localStorage.setItem( e4.redirect.localStorageKey, JSON.stringify( jsonStorage ) );
    },
    getUserConsent: function () {
        var objReturnValue,
            jsonStorage = JSON.parse( localStorage.getItem( e4.redirect.localStorageKey ) );
        if ( jsonStorage !== null ) {
            if ( new Date().getTime() < jsonStorage.timestamp ) {
                objReturnValue = JSON.parse( jsonStorage.value );
            }
            else {
                localStorage.removeItem( e4.redirect.localStorageKey );
                objReturnValue = undefined;
            }
        }
        else {
            objReturnValue = undefined;
        }
        return objReturnValue;
    }
};
